import { render, staticRenderFns } from "./mian15.vue?vue&type=template&id=2e989497&scoped=true"
import script from "./mian15.vue?vue&type=script&lang=ts"
export * from "./mian15.vue?vue&type=script&lang=ts"
import style0 from "./mian15.vue?vue&type=style&index=0&id=2e989497&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e989497",
  null
  
)

export default component.exports